(function() {
  var goldStyle = document.createElement('style');
  goldStyle.textContent = [
    ':root {',
    '  --color-primary-button-background: #F0C030 !important;',
    '  --color-primary-button-border: #F0C030 !important;',
    '  --color-primary-button-hover-background: #D4A820 !important;',
    '  --color-primary-button-hover-border: #D4A820 !important;',
    '  --color-selected-variant-background: #F0C030 !important;',
    '  --color-selected-variant-border: #F0C030 !important;',
    '  --color-selected-variant-hover-background: #D4A820 !important;',
    '  --color-selected-variant-hover-border: #D4A820 !important;',
    '}'
  ].join('\n');
  document.head.appendChild(goldStyle);

  if (!window.location.pathname.startsWith('/products/')) return;

  function productHasColorOption() {
    var labels = document.querySelectorAll('fieldset legend, .product-form__input label, [data-option-name]');
    for (var i = 0; i < labels.length; i++) {
      if (/colo(u)?r/i.test(labels[i].textContent)) return true;
    }
    try {
      var pjson = document.querySelector('[id^="ProductJson"], script[id*="ProductJson"]');
      if (pjson) {
        var pd = JSON.parse(pjson.textContent);
        if (pd.options && pd.options.some(function(o) { return /colo(u)?r/i.test(o); })) return true;
      }
    } catch(e) {}
    return false;
  }

  var COLOR_FIELD_HTML = [
    '<div style="margin-bottom:14px;"><label style="display:block;font-size:12px;margin-bottom:4px;opacity:0.8;">Color 1 (Primary)</label><input type="text" name="color1" placeholder="e.g. Matte Black, Navy Blue..." style="width:100%;padding:8px 12px;border-radius:6px;border:1px solid #F0C030;background:#162B5E;color:#FFFDF5;box-sizing:border-box;font-size:14px;"></div>',
    '<div style="margin-bottom:14px;"><label style="display:block;font-size:12px;margin-bottom:4px;opacity:0.8;">Color 2 (Secondary / Accents)</label><input type="text" name="color2" placeholder="e.g. Gold, White..." style="width:100%;padding:8px 12px;border-radius:6px;border:1px solid #F0C030;background:#162B5E;color:#FFFDF5;box-sizing:border-box;font-size:14px;"></div>',
    '<div style="margin-bottom:14px;"><label style="display:block;font-size:12px;margin-bottom:4px;opacity:0.8;">Color 3 (Optional)</label><input type="text" name="color3" placeholder="Optional third color..." style="width:100%;padding:8px 12px;border-radius:6px;border:1px solid #F0C030;background:#162B5E;color:#FFFDF5;box-sizing:border-box;font-size:14px;"></div>'
  ].join('');

  var modalHtml = [
    '<div id="arisai-color-modal" style="display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.7);z-index:99999;overflow-y:auto;">',
    '  <div style="background:#0f1e40;color:#FFFDF5;border:1px solid #F0C030;border-radius:14px;max-width:480px;margin:60px auto;padding:32px;position:relative;">',
    '    <button id="arisai-color-close" style="position:absolute;top:12px;right:16px;background:none;border:none;color:#FFFDF5;font-size:24px;cursor:pointer;">&times;</button>',
    '    <h3 style="margin:0 0 8px;font-size:18px;">Want a custom color?</h3>',
    '    <p style="margin:0 0 20px;font-size:13px;opacity:0.8;">Tell us your color preferences and we\'ll make it just for you.</p>',
    '    <form id="arisai-color-form" action="/contact" method="POST">',
    '      <input type="hidden" name="form_type" value="contact">',
    '      <input type="hidden" name="utf8" value="&#x2713;">',
    '      <input type="hidden" name="contact[subject]" id="arisai-subject" value="">',
    '      <div style="margin-bottom:14px;"><label style="display:block;font-size:12px;margin-bottom:4px;opacity:0.8;">Your Name</label><input type="text" name="contact[name]" required style="width:100%;padding:8px 12px;border-radius:6px;border:1px solid #F0C030;background:#162B5E;color:#FFFDF5;box-sizing:border-box;font-size:14px;"></div>',
    '      <div style="margin-bottom:14px;"><label style="display:block;font-size:12px;margin-bottom:4px;opacity:0.8;">Email *</label><input type="email" name="contact[email]" required style="width:100%;padding:8px 12px;border-radius:6px;border:1px solid #F0C030;background:#162B5E;color:#FFFDF5;box-sizing:border-box;font-size:14px;"></div>',
    '      <div style="margin-bottom:14px;"><label style="display:block;font-size:12px;margin-bottom:4px;opacity:0.8;">Phone Number</label><input type="tel" name="contact[phone]" style="width:100%;padding:8px 12px;border-radius:6px;border:1px solid #F0C030;background:#162B5E;color:#FFFDF5;box-sizing:border-box;font-size:14px;"></div>',
    '      <div id="arisai-color-fields"></div>',
    '      <div style="margin-bottom:20px;"><label style="display:block;font-size:12px;margin-bottom:4px;opacity:0.8;">Reference Image URL (optional)</label><input type="url" name="imageUrl" placeholder="https://..." style="width:100%;padding:8px 12px;border-radius:6px;border:1px solid #F0C030;background:#162B5E;color:#FFFDF5;box-sizing:border-box;font-size:14px;"></div>',
    '      <button type="submit" style="width:100%;padding:12px;background:#F0C030;color:#0f1e40;border:none;border-radius:6px;font-size:14px;font-weight:600;cursor:pointer;">Send Request</button>',
    '    </form>',
    '  </div>',
    '</div>',
    '<span id="arisai-custom-link" style="display:none;">Want a custom color?</span>'
  ].join('');

  document.addEventListener('DOMContentLoaded', function() {
    document.body.insertAdjacentHTML('beforeend', modalHtml);

    if (productHasColorOption()) {
      var cf = document.getElementById('arisai-color-fields');
      if (cf) cf.innerHTML = COLOR_FIELD_HTML;
    }

    var productTitle = document.querySelector('h1') || document.querySelector('[data-product-title]');
    var subjectField = document.getElementById('arisai-subject');
    if (productTitle && subjectField) {
      subjectField.value = 'Custom Request: ' + productTitle.textContent.trim();
    }

    var buyButtons = document.querySelector('buy-buttons, [data-type="buy-buttons"], .buy-buttons');
    var target = buyButtons || document.querySelector('form[action="/cart/add"]');
    var link = document.getElementById('arisai-custom-link');
    if (link) {
      link.style.cssText = 'display:block;text-align:left;margin-top:8px;font-size:11px;opacity:0.7;cursor:pointer;text-decoration:underline;';
      if (target) target.parentNode.insertBefore(link, target.nextSibling);
      else document.body.appendChild(link);
    }

    var modal = document.getElementById('arisai-color-modal');
    var closeBtn = document.getElementById('arisai-color-close');
    if (link && modal) link.addEventListener('click', function() { modal.style.display = 'block'; });
    if (closeBtn && modal) closeBtn.addEventListener('click', function() { modal.style.display = 'none'; });
    if (modal) modal.addEventListener('click', function(e) { if (e.target === modal) modal.style.display = 'none'; });

    var form = document.getElementById('arisai-color-form');
    if (form) {
      form.addEventListener('submit', function() {
        var c1 = form.querySelector('[name="color1"]');
        var c2 = form.querySelector('[name="color2"]');
        var c3 = form.querySelector('[name="color3"]');
        var img = form.querySelector('[name="imageUrl"]').value;
        var subject = document.getElementById('arisai-subject').value;
        var body = 'Product: ' + subject + '\n';
        if (c1 && c1.value) body += 'Color 1: ' + c1.value + '\n';
        if (c2 && c2.value) body += 'Color 2: ' + c2.value + '\n';
        if (c3 && c3.value) body += 'Color 3: ' + c3.value + '\n';
        if (img) body += 'Reference Image: ' + img + '\n';
        var bf = form.querySelector('[name="contact[body]"]');
        if (!bf) { bf = document.createElement('textarea'); bf.name = 'contact[body]'; bf.style.display = 'none'; form.appendChild(bf); }
        bf.value = body;
      });
    }
  });
})();